import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// assets
import alreadyHomeSingleCover from "../../assets/covers/alreadyHomeSingleCover.jpg";

function Landing() {
    return (
        <div className="landing">
            <h1>Caitlin Klotz</h1>
            <div className="card release">
                <div className="releaseCoverContainer">
                    <img
                        className="releaseCover"
                        src={alreadyHomeSingleCover}
                        alt="Already Home Single Cover"
                    />
                </div>
                <div className="releaseDetails">
                    <h2>Aleady Home</h2>
                    <p className="slogan">For when you need to feel safe</p>
                    <div className="listen">
                        <h3>Listen</h3>
                        <a className="cta" href="https://open.spotify.com/track/5IQ7PfwCp3YQZXcfRPXWf8">
                            <FontAwesomeIcon
                                icon="fa-brands fa-spotify"
                                className="icon"
                            />
                            Spotify
                        </a>
                        <a href="https://music.apple.com/us/song/already-home/1886406132">
                            <FontAwesomeIcon
                                icon="fa-brands fa-itunes-note"
                                className="icon"
                            />
                            Apple
                        </a>
                        <a href="https://music.amazon.ca/albums/B0GT3RGXKG&trackAsin=B0GT3MY1GQ">
                            <FontAwesomeIcon
                                icon="fa-brands fa-amazon"
                                className="icon"
                            />
                            Amazon
                        </a>
                        <a href="https://youtu.be/sfcZPp7rkVw?si=fbI3bU0HI-7d92YI">
                            <FontAwesomeIcon
                                icon="fa-brands fa-youtube"
                                className="icon"
                            />
                            YouTube
                        </a>
                    </div>
                </div>
            </div>
            <div className="card links">
                <a href="/">
                    <FontAwesomeIcon
                        icon="fa-solid fa-globe"
                        className="icon"
                    />
                    View Website
                </a>
                <a href="https://www.youtube.com/@CaitlinKlotzVEVO">
                    <FontAwesomeIcon
                        icon="fa-brands fa-youtube"
                        className="icon"
                    />
                    Watch Lyric Videos
                </a>
            </div>
            <div className="card socials">
                <div>
                    <a href="https://open.spotify.com/artist/7K7E5F2950LM3k0TSOdubf">
                        <FontAwesomeIcon
                            icon="fa-brands fa-spotify"
                            className="icon"
                        />
                    </a>
                    <a href="https://music.apple.com/artist/1790138283">
                        <FontAwesomeIcon
                            icon="fa-brands fa-itunes-note"
                            className="icon"
                        />
                    </a>
                    <a href="https://www.youtube.com/@caitlin.klotz.1">
                        <FontAwesomeIcon
                            icon="fa-brands fa-youtube"
                            className="icon"
                        />
                    </a>
                    <a href="https://music.amazon.ca/artists/B0DSW3SBWT/caitlin-klotz?marketplaceId=A2EUQ1WTGCTBG2&musicTerritory=CA&ref=dm_sh_nLZ3NfVEBqbELWkLK7lmelA6V">
                        <FontAwesomeIcon
                            icon="fa-brands fa-amazon"
                            className="icon"
                            />
                    </a>
                </div>
                <div>
                    <a href="https://www.instagram.com/caitlin.klotz.1">
                        <FontAwesomeIcon
                            icon="fa-brands fa-instagram"
                            className="icon"
                        />
                    </a>
                    <a href="https://www.threads.com/@caitlin.klotz.1">
                        <FontAwesomeIcon
                            icon="fa-brands fa-threads"
                            className="icon"
                        />
                    </a>
                    <a href="https://www.facebook.com/caitlin.klotz.2">
                        <FontAwesomeIcon
                            icon="fa-brands fa-facebook"
                            className="icon"
                        />
                    </a>
                    <a href="https://twitter.com/CaitlinKlotz">
                        <FontAwesomeIcon
                            icon="fa-brands fa-x-twitter"
                            className="icon"
                        />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Landing;